import { map } from "rxjs";
import { RemoteNotification } from "../../../model/RemoteNotification";
import { apiService } from "../../ApiService";

export const getNotifications = () => {
  return apiService
    .get<{ notifications: RemoteNotification[] }>({
      path: `public/user/notifications`,
      requiresAuthPolicy: "user",
      crm: true,
    })
    .pipe(map((res) => res.notifications));
};
